import { render, staticRenderFns } from "./ListOfSpeciesByFaunisticGroupTable.vue?vue&type=template&id=07b20f27&"
import script from "./ListOfSpeciesByFaunisticGroupTable.vue?vue&type=script&lang=ts&"
export * from "./ListOfSpeciesByFaunisticGroupTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDataTable,VSkeletonLoader})
